import React from 'react';
import cn from 'classnames/bind';
import { Responses500 } from '@consta/uikit/Responses500';
import { Responses403 } from '@consta/uikit/Responses403';
import { Responses503 } from '@consta/uikit/Responses503';
import { Responses404 } from '@consta/uikit/Responses404';
import { Route } from 'react-router-dom';
import { ErrorUrlEnum } from 'src/utils/enum';

// Styles
import styles from './styles.styl';
const cx = cn.bind(styles);

export interface ErrorHandlerProps {}

const ErrorHandler: React.FC<ErrorHandlerProps> = () => (
  <div className={cx('ErrorHandler')}>
    <Route path={ErrorUrlEnum.ERROR_500}>
      <Responses500
        className={cx('ErrorHandler__error')}
        title="При обработке запроса произошла ошибка"
        description="Повторите попытку позже"
        actions=" "
        size="l"
      />
    </Route>
    <Route path={ErrorUrlEnum.ERROR_403}>
      <Responses403
        className={cx('ErrorHandler__error')}
        title="Отказано в доступе"
        description=" "
        actions=" "
        size="l"
      />
    </Route>
    <Route path={ErrorUrlEnum.ERROR_503}>
      <Responses503
        className={cx('ErrorHandler__error')}
        title="Технические работы"
        description=" "
        actions=" "
        size="l"
      />
    </Route>
    <Route path={ErrorUrlEnum.ERROR_404}>
      <Responses404
        className={cx('Error404__error')}
        title="Такой страницы не существует"
        description=" "
        actions=" "
        size="l"
      />
    </Route>
  </div>
);

export default ErrorHandler;
